export default __webpack_public_path__ + "static/media/Thermo_Fisher_Scientific_logo.470b4a9c.png";